<template>
  <div v-if="items" class="flex flex-col items-center mt-16">
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%]">
      <h2 class="text-3xl font-semibold text-mainColor text-center mb-6">
        {{ items.name }}
      </h2>
      <div class="flex flex-col md:flex-row gap-6">
        <div class="w-full md:w-1/2 h-[320px]">
          <img
            :src="items.imageUrl"
            class="w-full h-full object-cover rounded-lg"
            alt="khmer force"
          />
        </div>
        <div class="w-full md:w-1/2 flex flex-col">
          <h3 class="text-xl font-semibold text-gray-800">{{ items.title }}</h3>
          <p class="pt-3 text-gray-600 leading-relaxed whitespace-pre-line text-justify">
            {{ items.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
export default {
  name: "KhmerForceSecurity",
  data() {
    return {
      items: {
        name: "",
        title: "",
        description: "",
        imageUrl: "",
      },
    };
  },
  mounted() {
    this.fetchDataSource();
  },
  methods: {
    async fetchDataSource() {
      const snapshot = await getDocs(collection(db, "khmerForceSecurity"));
      const docSnap = snapshot.docs[0];
        this.items = {
          name: docSnap.data().name,
          title: docSnap.data().title,
          description: docSnap.data().description,
          imageUrl: docSnap.data().imageUrl,
        };
    },
  },
};
</script>
